import { useMemo } from 'react';
import { filterCreators } from './factory';

export const useFilteredData = ({ data, value, filterType, options }) => {
  const filter = useMemo(
    () => filterCreators[filterType](value, options),
    [filterType, value, options]
  );

  return useMemo(() => filter(data), [filter, data]);
};
